export const QrtServiceFieldType = {
  Standard: { key: 1, value: "Standard" },
  Admin: { key: 2, value: "Admin" },
  Ip: { key: 3, value: "Ip" },
};

export const UtilityMeterDisplayCode = "U";

export const ScanMeterDisplayCode = "S";

export const maximumUtilityMetersForPrincipalMode = 5;
